import { format } from 'date-fns';

export function getStringFromState(
    text: string | null | undefined | number | Date,
    optional?: boolean
): string {
    if (optional && (text === null || text === undefined || text === '')) {
        return '';
    }

    if (text === null || text === undefined || text === '') {
        return '___';
    }

    if (text instanceof Date) {
        return format(text, 'd/M/yyyy');
    }

    return text.toString();
}
